export default __webpack_public_path__ + "static/media/tomates.45082a7d.jpg";